import Const from 'constants';
import {StackPlayerClassifier as CSStackPlayerClassifier} from 'components/organisms/correlation-stacking/services/stack-player-classifier';
import {StackPlayerClassifier as KPSStackPlayerClassifier} from 'services/key-player-stacking/stack-player-classifier';
import {StackPlayerClassifier as BaseStackPlayerClassifier} from 'services/stack-player-classifier';

function getKeyPlayerStackingAnalyzer(params) {
    const {playerPositionStacking, keyPlayerStackingGroupsStateId, runSettings, lineupId, rawLineups, players} = params;

    if (playerPositionStacking.isEnabled() && runSettings.hasRunSettingsByKey(keyPlayerStackingGroupsStateId)) {
        return new KPSStackPlayerClassifier({
            stacking: runSettings.getRunSettingsByKey(keyPlayerStackingGroupsStateId),
            simplexLineup: rawLineups.getLineup(lineupId),
            players,
        });
    }

    return new BaseStackPlayerClassifier();
}

function getNFLStackedPlayerAnalyzer(params) {
    const {correlationStacking, runSettings, players, lineupId, rawLineups} = params;

    if (
        correlationStacking.settings.isEnabled() &&
        runSettings.hasRunSettingsByKey(correlationStacking.settings.getStateId())
    ) {
        return new CSStackPlayerClassifier({
            players,
            stacking: runSettings.getRunSettingsByKey(correlationStacking.settings.getStateId()),
            simplexLineup: rawLineups.getLineup(lineupId),
        });
    }

    return getKeyPlayerStackingAnalyzer(params);
}

const StackedPlayerAnalyzerFactory = {
    createAnalyzer(config, initParams) {
        if (Const.LEAGUE_NFL === config.sport) {
            return getNFLStackedPlayerAnalyzer(initParams);
        } else if (inArray(config.sport, [Const.LEAGUE_CFB, Const.LEAGUE_NBA])) {
            return getKeyPlayerStackingAnalyzer(initParams);
        }

        throw new Error(`Factory ERR: unknown sport ${config.sport}`);
    },
};

export {StackedPlayerAnalyzerFactory};
